<script setup>

import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import {nextTick, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import axios from "axios";
import {useHead} from "@vueuse/head";
import Relate from "@/components/Relate.vue";
import EmailForm from "@/components/EmailForm.vue";


const route = useRoute()
const detail = ref({})


function get_detail(title) {
  let url = '/api/projects/?site='
  url = url + title
  axios
      .get(url)
      .then(response => {
        detail.value = response.data.results[0]
      })
      .catch(error => {
        console.log(error)
      })
}


onMounted(async () => {
  const scripts = [
    '/assets/js/vendor/modernizr-2.8.3.min.js',
    '/assets/js/vendor/jquery-3.5.1.min.js',
    '/assets/js/bootstrap.min.js',
    '/assets/js/isotope.pkgd.min.js',
    '/assets/js/owl.carousel.min.js',
    '/assets/js/jquery.nivo.slider.pack.js',
    '/assets/js/slick.min.js',
    '/assets/js/imagesloaded.pkgd.min.js',
    '/venobox/venobox.min.js',
    '/assets/js/jquery.appear.js',
    '/assets/js/jquery.knob.js',
    '/assets/js/BeerSlider.js',
    '/assets/js/theme-pluginjs.js',
    '/assets/js/jquery.meanmenu.js',
    '/assets/js/ajax-mail.js',
    '/assets/js/theme.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
  if (index < scripts.length) {
    const script = document.createElement('script');
    script.src = scripts[index];
    script.onload = () => loadScriptsSequentially(scripts, index + 1);
    document.body.appendChild(script);
  }
}

  await loadScriptsSequentially(scripts);
  const title = route.params.str
  await get_detail(title)
})

watch(detail, (newVal) => {
  if (newVal) {
    useHead({
      title: newVal.project_title,
      meta: [
        {
          name: 'keywords',
          content: newVal.project_title
        },
        {
          name: 'description',
          content: newVal.project_title
        }
      ]
    })
  }
})

</script>

<template>
  <Header/>
  <!-- breadcumb-area -->
  <div class="breadcumb-area">
    <div class="container">
      <div class="row">
        <div class="col-md-12 txtc  text-center ccase">
          <div class="brpt">
            <h2>Single Portfolio</h2>
          </div>
          <div class="breadcumb-inner">
            <ul>
              <li><a href="/">Home</a></li>
              <li><i class="fas fa-angle-right"></i></li>
              <li>Single Portfolio</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!--====== PORTFOLIO PART START ======-->
  <div class="witr_single_portfolio_a">
    <div class="container">
      <!-- 顶部：图片展示和信息区域 -->
      <div class="row">
        <!-- 大图展示区域 (移动设备上全宽，桌面设备上占2/3) -->
        <div class="col-lg-8 col-md-12 col-sm-12 mb-4">
          <div class="single_portfolio_preview">
            <img id="main-image" class="img-fluid" :src="detail.image_1" alt="Main product image">
          </div>

          <!-- 小图缩略图区域 (移动设备上放在大图下方) -->
          <div class="d-lg-none d-md-block d-sm-block mt-3">
            <div class="thumbnail-container">
              <div class="thumbnail-row">
                <div class="thumbnail-col">
                  <img class="thumbnail-img active" :src="detail.image_1" alt="Thumbnail 1">
                </div>
                <div class="thumbnail-col">
                  <img class="thumbnail-img" :src="detail.image_2" alt="Thumbnail 2">
                </div>
                <div class="thumbnail-col">
                  <img class="thumbnail-img" :src="detail.image_3" alt="Thumbnail 3">
                </div>
                <!-- 可以添加更多缩略图 -->
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧信息区域 (桌面设备上占1/3) -->
        <div class="col-lg-4 col-md-12 col-sm-12">
          <!-- 桌面设备上的缩略图 (移动设备上隐藏) -->
          <div class="d-none d-lg-block mb-4">
            <div class="thumbnail-container">
              <div class="thumbnail-row">
                <div class="thumbnail-col">
                  <img class="thumbnail-img active" :src="detail.image_1" alt="Thumbnail 1">
                </div>
                <div class="thumbnail-col">
                  <img class="thumbnail-img" :src="detail.image_2" alt="Thumbnail 2">
                </div>
                <div class="thumbnail-col">
                  <img class="thumbnail-img" :src="detail.image_3" alt="Thumbnail 3">
                </div>
              </div>
            </div>
          </div>

          <!-- 项目信息 -->
          <div class="portfolio-content portfolio-details-box">
            <div class="prots-contentg">
              <h2>Portfolio Information</h2>
              <ul class="portfolio-info-list">
                <li>
                  <b class="eleft">Project Name:</b>
                  <span class="eright" v-if="detail">{{ detail.project_title }}</span>
                </li>
                <li>
                  <b class="eleft">Category:</b>
                  <span class="eright" v-if="detail">{{ detail.tag }}</span>
                  <span class="eright" v-else> </span>
                </li>
                <li>
                  <b class="eleft">Complete Date:</b>
                  <span class="eright" v-if="detail">{{ detail.manual_date }}</span>
                </li>
              </ul>
            </div>

            <!-- 社交分享 -->
            <div class="kurigram-blog-social mt-4">
              <div class="kurigram-single-icon">
                <div class="kurigram-single-icon-inner">
                  <a href="https://www.facebook.com/profile.php?id=100083074701518"><i class="fa fa-facebook-f"></i></a>
                  <a href="https://www.youtube.com/channel/UCxr_xUVMtb6JGRJUMQ5mWRw"><i class="fab fa-youtube"></i></a>
                  <a href="https://www.linkedin.com/company/84045662/admin/"><i class="fab fa-linkedin"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 项目详情内容区域 -->
      <div class="row mt-5">
        <div class="col-12">
          <div class="portfolio-content portfolio-details-boxs">
            <div class="pr-title"><h2 v-if="detail">{{ detail.project_title }}</h2></div>
            <div class="prots-contentg">
              <section class="project-section">
                <iframe v-if="detail && detail.video" width="560" height="315" :src="detail.video"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                <div v-else>
                  <img v-if="detail" :src="detail.image_1" alt="" width="530"
                       height="480"/>
                </div>
                <h3 class="section-title">Project Description</h3>
                <p v-if="detail" v-html="detail.Description"></p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- kurigram_contact_area -->
  <EmailForm/>

  <Relate/>

  <Footer/>
</template>

<style scoped lang="scss">

</style>